import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from '../../core/services/auth-state.service';

export const UserGuard = (): CanActivateFn => {
  return (route: ActivatedRouteSnapshot) => {
    const authStateService = inject(AuthStateService);
    const router = inject(Router);

    if (!authStateService.isLoggedIn()) {
      router.navigate(['/login']);
      return false;
    }

    return true;
  };
};
